import styles from "./InSiteLogo.module.css";
import logo from "../../assets/logo.png";
import { useContext } from "react";
import DataContext from "../store/data-context";
export default function InSiteLogo() {
    const { closeApp } = useContext(DataContext);

    return <img src={logo} className={styles.logo} onClick={closeApp} />;
}
